import { createAsyncThunk } from '@reduxjs/toolkit';
import { useCustomAxios } from '../../shared/lib/customAxios';
import { IGst } from '../../shared/models/signup';

export const saveSellerBuyerDetailsApi = createAsyncThunk(
  'user/businessDetails',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();

    try {
      const response = await axiosPost('/party/create', reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response?.data ?? { message: error.message };
    }
  }
);

export const saveBankDetailsApi = createAsyncThunk(
  'user/bankDetails',
  async (reqBody: any) => {
    const { axiosPost } = useCustomAxios();

    try {
      const response = await axiosPost('/party/updateBankAccount', reqBody);
      return { data: response.data, status: response.status };
    } catch (error: any) {
      return error.response?.data ?? { message: error.message };
    }
  }
);
// OTP related endpoints used during signup

export const sendOtpApi = createAsyncThunk(
  'user/sendOtp',
  async(reqBody:any)=> {
    const {axiosPost} = useCustomAxios();
    
    try {
      const res = await axiosPost('/authenticator/sendOtp',reqBody);
      return { data: res.data, status: res.status };
    } catch (error:any) {
      return error.response?.data ?? { message: error.message };
    }
  }
)
export const verifyOtpApi = createAsyncThunk(
  'user/verifyOtp',
  async(reqBody:any)=> {
    const {axiosPost} = useCustomAxios();
    
    try {
      const res = await axiosPost('/authenticator/verifyOtp',reqBody);
      return { data: res.data, status: res.status };
    } catch (error:any) {
      return error.response?.data ?? { message: error.message };
    }
  }
)
export const gstIntegrationApi = createAsyncThunk(
  'user/verifyGst',
  async(reqBody:IGst)=> {
    const {axiosPost} = useCustomAxios();

    try {
      const res = await axiosPost('/party/verifyGSTIN',reqBody)
      return {data: res.data, status: res.status}
    } catch (error:any) {
      return error.response?.data ?? { message: error.message }
    }
  }
)